export const DRIVER_FILTER_CATEGORY: { key: string; value: TDriverAppSearchItem }[] = [
  { key: '팀 이름', value: 'name' },
  { key: '소속 매니저 이름', value: 'managerName' },
  { key: '소속 드라이버 이름', value: 'driverName' },
];
